module.exports = __webpack_public_path__ + "static/media/header_pdf.88cd9cb6.jpg";